import React, { useState } from 'react';
import { Typography, Button, Video, Modal } from '../../components';
import { Container, Introduction, Informatie, Downloadable, Aanmelden, IntroductionText, FlexButton } from './styled';
import { Ervaringen } from '../../subpages';

export default function JGZ(props) {
    const [openModalAanmelden, setModalAanmelden] = useState(false);

    const AanmeldenContent = (props) => {
        return (
            <Aanmelden color={props.color}>
                <Typography type='h2' style={{ fontSize: '2em' }}>Contact</Typography>
                <Button text='Plan een gesprek' to='/gesprek' style={{ margin: 'auto' }} />
            </Aanmelden>
        )
    }

    return (
        <Container>
            <Introduction>
                <IntroductionText>
                    <div>
                        <Typography type='caps' style={{ color: '#145f68', fontSize: '1em', padding: '0' }}>JGZ</Typography>
                        <Typography type='h1' style={{ color: '#032d34' }}>NOLIA BabyFeeding:</Typography>
                    </div>
                    <Typography type='h2' style={{ color: '#145f68', fontSize: '1.3em' }}>voeden met vertrouwen<br/>door zelfverzekerde ouders</Typography><br />
                    <Button text='Plan een gesprek' to='/gesprek' style={{ margin: 'auto' }} />
                </IntroductionText>
                <div style={{ zIndex: '5' }}>
                    <Video videoId='QncsEHveSdk' width={'45vw'} />
                </div>
            </Introduction>
            <Informatie>
                <Downloadable>
                    <Typography type='h2'>Informatie</Typography>
                    <FlexButton>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2em', alignItems: 'center'}}>
                    <Button
                        href='https://babyfeeding.nl/opt/gids-voor-professionals'
                        text='Gids voor professionals'
                        buttonstyle="secondary" style={{ margin: 'auto' }}
                        target='_blank'
                    />
                    <Button
                        href='https://babyfeeding.nl/opt/routekaart-ketenpartners'
                        text='Routekaart NOLIA BabyFeeding'
                        buttonstyle='secondary' style={{ margin: 'auto' }}
                        target='_blank'
                    />
                    </div>
                    </FlexButton>
                </Downloadable>
            </Informatie>
            <Ervaringen />
            <AanmeldenContent color='#F1E3D4' />
            <ModalAanmelden
                open={openModalAanmelden}
                onClose={() => setModalAanmelden(false)}
            />
        </Container>
    )
}

export const ModalAanmelden = (props) => {
    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
        >
            <Typography type='h2' as='h3'>Aanmelden</Typography>
            <br />
            <Typography>
                Wat fijn dat je interesse hebt in NOLIA BabyFeeding.
                Momenteel werken we aan verschillende onderdelen van onze website, waaronder de automatisering achter de knop ‘Aanmelden’.
                We willen je daarom vragen je aanmelding te mailen naar <a href='mailto:info@babyfeeding.nl'>info@babyfeeding.nl</a>.
            </Typography>
        </Modal>
    )
}